module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento4.549d4ee4.svg";